export default "__VITE_ASSET__Bq37MVyD__"